import { render } from "./AddShopMealDialog.vue?vue&type=template&id=7a0f7bbc&scoped=true&ts=true"
import script from "./AddShopMealDialog.vue?vue&type=script&lang=ts"
export * from "./AddShopMealDialog.vue?vue&type=script&lang=ts"

import "./AddShopMealDialog.vue?vue&type=style&index=0&id=7a0f7bbc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a0f7bbc"]])

export default __exports__